const disableBodyScroll = (value) => {
  if (value) {
    document.body.style.overflowY = 'hidden'
    return
  }
  document.body.style.overflowY = 'auto'
}

export default disableBodyScroll
